import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  SurgicalTreatmentCompactReportTableComponentModule,
  SurgicalTreatmentCompactReportTableComponent
} from './surgical-treatment-compact-report-table/surgical-treatment-compact-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';

@Component({
  selector: 'stx-surgical-treatments-compact-report',
  templateUrl: './surgical-treatments-compact-report.component.html',
  imports: [
    GenericPageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    SurgicalTreatmentCompactReportTableComponent,
    AsyncPipe,
    TranslateModule
  ]
})
export class SurgicalTreatmentsCompactReportComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'SURGICAL_TREATMENTS_COMPACT',
    downloadOptions: {},
    filters: {
      age: true,
      deIdentification: true,
      gender: true,
      geography: true,
      latestCases: true,
      organizationsTree: true,
      recordDate: true,
      qualityAssurance: true,
      surgicalIntervention: true,
      surgeons: true
    }
  };

  showPagination = true;
  deIdentify = false;

  applyFilters(pagination: PaginationSortingModel) {
    this.showPagination = this.reportService.latestCasesFilterActive();
    this.deIdentify = this.reportService.reportFiltersFormGroup.get('deIdentification')?.value;
    this.reportTableDataService.prepareList('SURGICAL_TREATMENTS_COMPACT', this.reportService.model, pagination);
  }
}
@NgModule({
  imports: [
    ReportFiltersModule,
    CommonModule,
    SurgicalTreatmentCompactReportTableComponentModule,
    TranslateModule,
    GeneralCommonsModule,
    SurgicalTreatmentsCompactReportComponent
  ],
  exports: [SurgicalTreatmentsCompactReportComponent]
})
export class SurgicalTreatmentsCompactReportModule {}
